var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loader page-loader-logo"},[_c('img',{staticClass:"p-2",attrs:{"alt":"Logo","src":"https://www.serpar.gob.pe/wp-content/uploads/2023/01/logo-serpar-2023-blanco.png","width":"150"}}),_vm._v(" "),_c('i',{staticClass:"el-icon-loading text-white h2"})])}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/Loader.vue?vue&type=template&id=4de46636
// module id = null
// module chunks = 